module.exports = __webpack_public_path__ + "img/menu_gomb_tmkk.5f9fb132.png";